module.exports = require('./components/app');
